import SidebarCustomSection from "../common/custom-sections";
export default class SidebarAnonymousCustomSections extends SidebarCustomSection {
  anonymous = true;
}